// <!-- The core Firebase JS SDK is always required and must be listed first -->
// <script src="https://www.gstatic.com/firebasejs/6.3.0/firebase-app.js"></script>

// <!-- TODO: Add SDKs for Firebase products that you want to use
//      https://firebase.google.com/docs/web/setup#config-web-app -->

// <script>
import firebase from 'firebase/app'
import 'firebase/firestore'
  // Your web app's Firebase configuration
  var firebaseConfig = {
    apiKey: "AIzaSyBocYLbMEuUhJdjAx8guIP89J-yrGtMgpM",
    authDomain: "iventure-v1.firebaseapp.com",
    databaseURL: "https://iventure-v1.firebaseio.com",
    projectId: "iventure-v1",
    storageBucket: "iventure-v1.appspot.com",
    messagingSenderId: "536766960981",
    appId: "1:536766960981:web:8191048bbaef0d4b"
  };
  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);
  const db = firebase.firestore();

  export default db;
//</script>